import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { Chip } from '@mui/material';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import BasicDropdownOption from '../BasicDropdownOption/BasicDropdownOption';
import { useWindowSize } from '../../../../../../utils/hooks';
import colors from '../../../../../../scss/colors';
import classes from './ContractorFilter.module.scss';
import { responsiveSizeTimesheet } from '../../../../../../utils/constants';

const StyledInput = styled(InputBase)(({ theme }) => ({
  padding: '20px 20px 28px 20px',
  width: '100%',
  '& input': {
    borderRadius: 10,
    backgroundColor: colors.WHITE,
    padding: '14px 14px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    border: `1px solid ${colors.LIGHT_GREY}`,
    fontSize: 14
  }
}));

export default function ContractorFilter({ contractors, selectedContractor, changeContractor, dateBackAction }) {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  const handleFilterToggle = () => {
    setOpen(!open);
    dateBackAction('', selectedContractor, '');
  };

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.contractor')}
      text={
        !selectedContractor.FirstName || selectedContractor === t('common.general.all')
          ? t('dashboard.timesheets.filters.contractor')
          : `${selectedContractor?.FirstName || ''} ${selectedContractor?.LastName || ''}`
      }
      active={
        selectedContractor.FirstName && selectedContractor.LastName && selectedContractor !== t('common.general.all')
      }
      open={open}
      setOpen={handleFilterToggle}
      extraHeader={{
        enabled: !!selectedContractor,
        label: t('common.filters.reset'),
        action: () => {
          changeContractor('');
          setText('');
          setOpen(false);
        }
      }}
    >
      <div className={classes.container}>
        <StyledInput
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={t('dashboard.timesheets.filters.addcontractorname')}
        />
        {width > responsiveSizeTimesheet && (
          <BasicDropdownOption
            key={t('common.general.all')}
            text={t('common.general.all')}
            selected={!selectedContractor.FirstName && !selectedContractor.LastName}
            clickHandler={() => {
              changeContractor({ FirstName: '', LastName: '' });
              setOpen(false);
              setText('');
            }}
          />
        )}
        <div className={classes.listContainer}>
          {width <= responsiveSizeTimesheet && (
            <Chip
              variant={!selectedContractor.FirstName && !selectedContractor.LastName ? 'filled' : 'outlined'}
              key={selectedContractor}
              label={t('common.general.all')}
              onClick={() => {
                changeContractor({ FirstName: '', LastName: '' });
                setText('');
                setOpen(false);
              }}
              sx={{
                '&.MuiChip-root': {
                  backgroundColor:
                    !selectedContractor.FirstName && !selectedContractor.LastName
                      ? colors.NAVY_BLUE
                      : colors.PAGE_BACKGROUND,
                  color:
                    !selectedContractor.FirstName && !selectedContractor.LastName ? colors.WHITE : colors.MEDIUM_GREY,
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '19px'
                }
              }}
            />
          )}
          {contractors &&
            contractors
              .filter((item) =>
                text
                  ? item.FirstName.toLowerCase().includes(text.toLowerCase()) ||
                    item.LastName.toLowerCase().includes(text.toLowerCase())
                  : true
              )
              .map((contractor) =>
                width > responsiveSizeTimesheet ? (
                  <BasicDropdownOption
                    key={contractor}
                    text={
                      contractor?.FirstName
                        ? `${contractor?.FirstName} ${contractor?.LastName}`
                        : t('common.general.all')
                    }
                    selected={JSON.stringify(selectedContractor) === JSON.stringify(contractor)}
                    clickHandler={() => {
                      changeContractor(contractor.FirstName ? contractor : { FirstName: '', LastName: '' });
                      setOpen(false);
                    }}
                  />
                ) : (
                  <Chip
                    variant={JSON.stringify(selectedContractor) === JSON.stringify(contractor) ? 'filled' : 'outlined'}
                    key={contractor}
                    label={
                      contractor?.FirstName
                        ? `${contractor?.FirstName} ${contractor?.LastName}`
                        : t('common.general.all')
                    }
                    onClick={() => {
                      changeContractor(contractor.FirstName ? contractor : { FirstName: '', LastName: '' });
                      setOpen(false);
                    }}
                    sx={{
                      '&.MuiChip-root': {
                        maxWidth: '160px',
                        backgroundColor:
                          JSON.stringify(selectedContractor) === JSON.stringify(contractor)
                            ? colors.NAVY_BLUE
                            : colors.PAGE_BACKGROUND,
                        color:
                          JSON.stringify(selectedContractor) === JSON.stringify(contractor)
                            ? colors.WHITE
                            : colors.MEDIUM_GREY,
                        fontStyle: 'normal',
                        fontWeight: '500',
                        fontSize: '16px',
                        lineHeight: '19px'
                      }
                    }}
                  />
                )
              )}
        </div>
      </div>
    </BasicFilterDropdown>
  );
}
